import {
	CONFIRM_FORGET_PASSWORD_ROUTE_ID,
	RESET_PASSWORD_ROUTE_ID,
} from 'root/src/shared/descriptions/routes/routeIds'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
import { authApi } from 'root/src/shared/util/authApi'
import getDomainRoute from 'root/src/client/util/getDomainRoute'

export default ({ email }) => async () => {
	await authApi.forgotPassword({
		email,
		redirectUrl: getDomainRoute(RESET_PASSWORD_ROUTE_ID),
	})
	return pushRouteClient({ routeId: CONFIRM_FORGET_PASSWORD_ROUTE_ID })
}
